import moment from 'moment'
import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as AddEditModal from './add-edit-modal'
import * as Constants from './constants'
import * as Types from './types'

export interface View extends Sortable.SortableViewState, IsActive.FilterableState {
}

export interface State {
  form: AddEditModal.FormState
  modal: AddEditModal.ModalState
  view: View
  data?: Types.Data
  editor?: AddEditModal.EditorState,
}
export interface WrappedState { leadText: State }

const normalizeTypes: Sortable.TypeNormalizer<Types.LeadText> =
  (payload: Sortable.SortableData<Types.LeadText>): Sortable.SortableData<Types.LeadText> => {
  return payload.map((lt: Types.LeadText) => ({
    ...lt,
    created_datetime: lt.created ? moment(lt.created) : null,
    end_datetime: lt.end_date ? moment(lt.end_date) : null,
    start_datetime: lt.start_date ? moment(lt.start_date) : null,
    updated_datetime: lt.updated ? moment(lt.updated) : null,
  }))
}

const reducerEvent: Sortable.ReducerEvent<Types.LeadText> = {
  defaultSort: {field: 'id', dir: 'desc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_LEAD_TEXT,
}

const emptyViewState: View = {
  filter: IsActive.FILTER_STATUS_ACTIVE,
  isLoading: false,
  sort: [],
}

const spinnerReducer = (state: AddEditModal.FormState, action: Redux.Action) => {
  switch (action.type) {
    case Request.requestConstant(Constants.POST_LEAD_TEXT) :
    case Request.requestConstant(Constants.PUT_LEAD_TEXT) :
      return {
        ...state,
        isSaving: !state.isSaving,
      }
    case Request.successConstant(Constants.POST_LEAD_TEXT):
    case Request.successConstant(Constants.PUT_LEAD_TEXT):
      return {
        ...state,
        isSaving: !state.isSaving,
      }
    default:
      return state
  }

}

export const reducer = Redux.combineReducers({
  data: IsActive.chainedReducer(Sortable.stateReducer(reducerEvent), Constants.LEAD_TEXT_STATUS_UPDATE),
  editor: AddEditModal.editorStateReducer,
  form: Request.reducerChain([AddEditModal.formReducer, spinnerReducer]),
  modal: AddEditModal.modalReducer,
  view: IsActive.filterReducer(
    Sortable.viewReducer(reducerEvent), Constants.FETCH_LEAD_TEXT, emptyViewState),
})



// WEBPACK FOOTER //
// ./src/pages/lead-text/reducer.ts